import { useState } from 'react';
import { updateJob } from '../api/jobs-api';
import { extractApiErrorMessage } from '@/lib/utils';
import type { JobFormData, JobDetailDto } from '../types';

/**
 * Hook for updating job details (description and notes)
 */
export function useUpdateJob() {
  const [isUpdating, setIsUpdating] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const updateJobDetails = async (
    jobId: number,
    data: JobFormData
  ): Promise<JobDetailDto | null> => {
    setIsUpdating(true);
    setError(null);

    try {
      const updatedJob = await updateJob(jobId, data);
      return updatedJob;
    } catch (err) {
      const errorMessage = extractApiErrorMessage(err, 'Failed to update job');
      setError(errorMessage);
      return null;
    } finally {
      setIsUpdating(false);
    }
  };

  return {
    updateJobDetails,
    isUpdating,
    error,
  };
}
